document.addEventListener("DOMContentLoaded", function () {
    function setImageSize(img) {
        if (!img.hasAttribute("width") && !img.hasAttribute("height")) {
            img.setAttribute("width", img.naturalWidth);
            img.setAttribute("height", img.naturalHeight);
        }
    }

    document.querySelectorAll("img").forEach((img) => {
        if (img.complete) {
            setImageSize(img);
        } else {
            img.onload = function () {
                setImageSize(img);
            };
        }
    });
});